module.exports = __webpack_public_path__ + "static/media/lamps-plus_2x.fc3b997d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header-photos/lamps-plus_2x.jpg
// module id = 840
// module chunks = 27